import { render, staticRenderFns } from "./MemberAreaModuleDetail.vue?vue&type=template&id=54a84989&scoped=true&"
import script from "./MemberAreaModuleDetail.vue?vue&type=script&lang=js&"
export * from "./MemberAreaModuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaModuleDetail.vue?vue&type=style&index=0&id=54a84989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a84989",
  null
  
)

export default component.exports